// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import echarts from 'echarts'
import Element from 'element-ui'
import axios from 'axios' //导入axios
import 'element-ui/lib/theme-chalk/index.css';
import { VueJsonp } from 'vue-jsonp'
import Vant from 'vant'
import 'vant/lib/index.css';

Vue.use(Vant)
Vue.use(Element)
Vue.use(VueJsonp)
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios //修改原始数据
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
//换个低版本的试一下



// WEBPACK FOOTER //
// ./src/main.js